@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(340_824_700)
public val Res.string.day_wednesday: StringResource by lazy {
      StringResource("string:day_wednesday", "day_wednesday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106862, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 149278, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95961, 33),
      ))
    }

@delegate:ResourceContentHash(164_587_562)
public val Res.string.day_wednesday_in_sentence: StringResource by lazy {
      StringResource("string:day_wednesday_in_sentence", "day_wednesday_in_sentence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106820, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 149228, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95915, 45),
      ))
    }

@delegate:ResourceContentHash(1_404_081_567)
public val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108401, 22),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 151821, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97380, 22),
      ))
    }

@delegate:ResourceContentHash(-612_305_544)
public val Res.string.delete_account: StringResource by lazy {
      StringResource("string:delete_account", "delete_account", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108269, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 151605, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97252, 42),
      ))
    }

@delegate:ResourceContentHash(-401_482_036)
public val Res.string.delete_account_confirm: StringResource by lazy {
      StringResource("string:delete_account_confirm", "delete_account_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106892, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 149316, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95995, 54),
      ))
    }

@delegate:ResourceContentHash(569_343_118)
public val Res.string.delete_account_other_apps: StringResource by lazy {
      StringResource("string:delete_account_other_apps", "delete_account_other_apps", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 106943, 317),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 149391, 529),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96050, 309),
      ))
    }

@delegate:ResourceContentHash(131_641_120)
public val Res.string.delete_account_owns_workplaces: StringResource by lazy {
      StringResource("string:delete_account_owns_workplaces", "delete_account_owns_workplaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 107261, 202),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 149921, 366),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96360, 198),
      ))
    }

@delegate:ResourceContentHash(-447_712_889)
public val Res.string.delete_account_text: StringResource by lazy {
      StringResource("string:delete_account_text", "delete_account_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 107464, 651),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 150288, 1079),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 96559, 543),
      ))
    }

@delegate:ResourceContentHash(814_118_851)
public val Res.string.delete_account_title: StringResource by lazy {
      StringResource("string:delete_account_title", "delete_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108116, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 151368, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97103, 56),
      ))
    }

@delegate:ResourceContentHash(-935_993_838)
public val Res.string.delete_account_type: StringResource by lazy {
      StringResource("string:delete_account_type", "delete_account_type", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108165, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 151461, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97160, 55),
      ))
    }

@delegate:ResourceContentHash(-780_987_348)
public val Res.string.delete_account_word: StringResource by lazy {
      StringResource("string:delete_account_word", "delete_account_word", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108233, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 151553, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97216, 35),
      ))
    }

@delegate:ResourceContentHash(-1_949_331_316)
public val Res.string.delete_named_confirm: StringResource by lazy {
      StringResource("string:delete_named_confirm", "delete_named_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108308, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 151692, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97295, 84),
      ))
    }

@delegate:ResourceContentHash(-1_759_833_680)
public val Res.string.desktop_sign_in_browser_done_text: StringResource by lazy {
      StringResource("string:desktop_sign_in_browser_done_text", "desktop_sign_in_browser_done_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108424, 113),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 151860, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97403, 105),
      ))
    }

@delegate:ResourceContentHash(1_851_028_109)
public val Res.string.desktop_sign_in_browser_done_title: StringResource by lazy {
      StringResource("string:desktop_sign_in_browser_done_title", "desktop_sign_in_browser_done_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108538, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152034, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97509, 82),
      ))
    }

@delegate:ResourceContentHash(-639_500_340)
public val Res.string.desktop_sign_in_browser_failed: StringResource by lazy {
      StringResource("string:desktop_sign_in_browser_failed", "desktop_sign_in_browser_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108625, 138),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152129, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97592, 122),
      ))
    }

@delegate:ResourceContentHash(-757_525_355)
public val Res.string.desktop_update_available: StringResource by lazy {
      StringResource("string:desktop_update_available", "desktop_update_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108764, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152300, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97715, 68),
      ))
    }

@delegate:ResourceContentHash(-17_722_174)
public val Res.string.desktop_update_download: StringResource by lazy {
      StringResource("string:desktop_update_download", "desktop_update_download", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108853, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152405, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97784, 43),
      ))
    }

@delegate:ResourceContentHash(1_543_930_004)
public val Res.string.desktop_update_later: StringResource by lazy {
      StringResource("string:desktop_update_later", "desktop_update_later", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108897, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152469, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97828, 36),
      ))
    }

@delegate:ResourceContentHash(541_815_871)
public val Res.string.details: StringResource by lazy {
      StringResource("string:details", "details", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108938, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152518, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97865, 27),
      ))
    }

@delegate:ResourceContentHash(1_971_621_595)
public val Res.string.dialog_saved_live: StringResource by lazy {
      StringResource("string:dialog_saved_live", "dialog_saved_live", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 108970, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152558, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97893, 73),
      ))
    }

@delegate:ResourceContentHash(-1_309_220_877)
public val Res.string.dialog_section_access: StringResource by lazy {
      StringResource("string:dialog_section_access", "dialog_section_access", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109036, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152652, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 97967, 37),
      ))
    }

@delegate:ResourceContentHash(-483_725_196)
public val Res.string.dialog_section_assignment: StringResource by lazy {
      StringResource("string:dialog_section_assignment", "dialog_section_assignment", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109078, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152698, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98005, 49),
      ))
    }

@delegate:ResourceContentHash(1_099_835_850)
public val Res.string.dialog_section_bank: StringResource by lazy {
      StringResource("string:dialog_section_bank", "dialog_section_bank", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109128, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152764, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98055, 39),
      ))
    }

@delegate:ResourceContentHash(-722_648_126)
public val Res.string.dialog_section_basics: StringResource by lazy {
      StringResource("string:dialog_section_basics", "dialog_section_basics", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109168, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152812, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98095, 37),
      ))
    }

@delegate:ResourceContentHash(-1_615_227_227)
public val Res.string.dialog_section_contact: StringResource by lazy {
      StringResource("string:dialog_section_contact", "dialog_section_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109214, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152862, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98133, 42),
      ))
    }

@delegate:ResourceContentHash(-811_018_599)
public val Res.string.dialog_section_contract: StringResource by lazy {
      StringResource("string:dialog_section_contract", "dialog_section_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109257, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152917, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98176, 43),
      ))
    }

@delegate:ResourceContentHash(-1_066_134_395)
public val Res.string.dialog_section_engagement: StringResource by lazy {
      StringResource("string:dialog_section_engagement", "dialog_section_engagement", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109297, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 152969, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98220, 53),
      ))
    }

@delegate:ResourceContentHash(-1_399_376_729)
public val Res.string.dialog_section_pay: StringResource by lazy {
      StringResource("string:dialog_section_pay", "dialog_section_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109412, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153124, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98331, 30),
      ))
    }

@delegate:ResourceContentHash(1_377_615_770)
public val Res.string.dialog_section_payroll_facts: StringResource by lazy {
      StringResource("string:dialog_section_payroll_facts", "dialog_section_payroll_facts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109343, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153031, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98274, 56),
      ))
    }

@delegate:ResourceContentHash(-1_778_836_424)
public val Res.string.dialog_section_week: StringResource by lazy {
      StringResource("string:dialog_section_week", "dialog_section_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109459, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153167, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98362, 35),
      ))
    }

@delegate:ResourceContentHash(-1_845_392_554)
public val Res.string.documents_add: StringResource by lazy {
      StringResource("string:documents_add", "documents_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109547, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153283, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98446, 37),
      ))
    }

@delegate:ResourceContentHash(-299_182_616)
public val Res.string.documents_add_title: StringResource by lazy {
      StringResource("string:documents_add_title", "documents_add_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109499, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153215, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98398, 47),
      ))
    }

@delegate:ResourceContentHash(1_823_589_709)
public val Res.string.documents_delete_confirm: StringResource by lazy {
      StringResource("string:documents_delete_confirm", "documents_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109589, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153345, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98484, 96),
      ))
    }

@delegate:ResourceContentHash(-1_804_383_581)
public val Res.string.documents_delete_title: StringResource by lazy {
      StringResource("string:documents_delete_title", "documents_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109694, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153486, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98581, 50),
      ))
    }

@delegate:ResourceContentHash(-1_422_826_095)
public val Res.string.documents_deleted: StringResource by lazy {
      StringResource("string:documents_deleted", "documents_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109745, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153561, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98632, 49),
      ))
    }

@delegate:ResourceContentHash(-2_095_150_793)
public val Res.string.documents_drop: StringResource by lazy {
      StringResource("string:documents_drop", "documents_drop", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109799, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153635, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98682, 78),
      ))
    }

@delegate:ResourceContentHash(1_310_511_177)
public val Res.string.documents_empty: StringResource by lazy {
      StringResource("string:documents_empty", "documents_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109878, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153742, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98761, 47),
      ))
    }

@delegate:ResourceContentHash(1_410_115_584)
public val Res.string.documents_expires_on: StringResource by lazy {
      StringResource("string:documents_expires_on", "documents_expires_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109996, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153920, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98875, 44),
      ))
    }

@delegate:ResourceContentHash(375_140_495)
public val Res.string.documents_expires_on_hint: StringResource by lazy {
      StringResource("string:documents_expires_on_hint", "documents_expires_on_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 109926, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153818, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98809, 65),
      ))
    }

@delegate:ResourceContentHash(1_489_520_495)
public val Res.string.documents_expiry_hr_records: StringResource by lazy {
      StringResource("string:documents_expiry_hr_records", "documents_expiry_hr_records", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 110045, 179),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 153989, 279),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98920, 155),
      ))
    }

@delegate:ResourceContentHash(65_943_964)
public val Res.string.documents_expiry_invalid: StringResource by lazy {
      StringResource("string:documents_expiry_invalid", "documents_expiry_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 110225, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 154269, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99076, 72),
      ))
    }

@delegate:ResourceContentHash(1_716_733_725)
public val Res.string.documents_expiry_records_dates: StringResource by lazy {
      StringResource("string:documents_expiry_records_dates", "documents_expiry_records_dates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 110302, 246),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 154366, 402),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99149, 222),
      ))
    }

@delegate:ResourceContentHash(-1_731_586_528)
public val Res.string.documents_expiry_until: StringResource by lazy {
      StringResource("string:documents_expiry_until", "documents_expiry_until", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 110549, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 154769, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99372, 54),
      ))
    }

@delegate:ResourceContentHash(209_703_352)
public val Res.string.documents_file_empty: StringResource by lazy {
      StringResource("string:documents_file_empty", "documents_file_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 110600, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 154832, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99427, 52),
      ))
    }

@delegate:ResourceContentHash(-683_670_653)
public val Res.string.documents_file_too_large: StringResource by lazy {
      StringResource("string:documents_file_too_large", "documents_file_too_large", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 110653, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 154897, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99480, 76),
      ))
    }

@delegate:ResourceContentHash(-1_091_289_754)
public val Res.string.documents_file_unreadable: StringResource by lazy {
      StringResource("string:documents_file_unreadable", "documents_file_unreadable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 110730, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 154982, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99557, 69),
      ))
    }

@delegate:ResourceContentHash(2_019_878_849)
public val Res.string.documents_file_unsupported: StringResource by lazy {
      StringResource("string:documents_file_unsupported", "documents_file_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 110808, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 155080, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99627, 122),
      ))
    }

@delegate:ResourceContentHash(654_164_525)
public val Res.string.documents_intro_mine: StringResource by lazy {
      StringResource("string:documents_intro_mine", "documents_intro_mine", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 110931, 252),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 155259, 456),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99750, 248),
      ))
    }

@delegate:ResourceContentHash(-480_100_673)
public val Res.string.documents_intro_team: StringResource by lazy {
      StringResource("string:documents_intro_team", "documents_intro_team", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 111184, 240),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 155716, 456),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 99999, 240),
      ))
    }

@delegate:ResourceContentHash(-1_229_522_160)
public val Res.string.documents_medical_hint: StringResource by lazy {
      StringResource("string:documents_medical_hint", "documents_medical_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 111425, 142),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 156173, 262),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100240, 138),
      ))
    }

@delegate:ResourceContentHash(1_600_254_109)
public val Res.string.documents_mine: StringResource by lazy {
      StringResource("string:documents_mine", "documents_mine", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 111568, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 156436, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100379, 38),
      ))
    }

@delegate:ResourceContentHash(486_888_891)
public val Res.string.documents_no_expiry: StringResource by lazy {
      StringResource("string:documents_no_expiry", "documents_no_expiry", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 111611, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 156495, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100418, 47),
      ))
    }

@delegate:ResourceContentHash(1_635_108_905)
public val Res.string.documents_not_available: StringResource by lazy {
      StringResource("string:documents_not_available", "documents_not_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 111667, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 156563, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100466, 87),
      ))
    }

@delegate:ResourceContentHash(1_489_855_146)
public val Res.string.documents_not_signature: StringResource by lazy {
      StringResource("string:documents_not_signature", "documents_not_signature", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 111755, 123),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 156667, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100554, 115),
      ))
    }

@delegate:ResourceContentHash(-689_852_712)
public val Res.string.documents_open: StringResource by lazy {
      StringResource("string:documents_open", "documents_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 111879, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 156839, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100670, 30),
      ))
    }

@delegate:ResourceContentHash(1_545_445_534)
public val Res.string.documents_queue: StringResource by lazy {
      StringResource("string:documents_queue", "documents_queue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 111914, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 156886, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100701, 51),
      ))
    }

@delegate:ResourceContentHash(-1_078_189_433)
public val Res.string.documents_refused: StringResource by lazy {
      StringResource("string:documents_refused", "documents_refused", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 111966, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 156954, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100753, 73),
      ))
    }

@delegate:ResourceContentHash(1_600_254_109)
public val Res.string.documents_title_mine: StringResource by lazy {
      StringResource("string:documents_title_mine", "documents_title_mine", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112044, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157068, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100827, 44),
      ))
    }

@delegate:ResourceContentHash(482_342_549)
public val Res.string.documents_title_of: StringResource by lazy {
      StringResource("string:documents_title_of", "documents_title_of", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112093, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157133, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100872, 46),
      ))
    }

@delegate:ResourceContentHash(375_452_569)
public val Res.string.documents_transfer_failed: StringResource by lazy {
      StringResource("string:documents_transfer_failed", "documents_transfer_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112140, 137),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157192, 185),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 100919, 129),
      ))
    }

@delegate:ResourceContentHash(867_893_484)
public val Res.string.documents_type: StringResource by lazy {
      StringResource("string:documents_type", "documents_type", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112429, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157589, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101204, 30),
      ))
    }

@delegate:ResourceContentHash(-811_018_599)
public val Res.string.documents_type_contract: StringResource by lazy {
      StringResource("string:documents_type_contract", "documents_type_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112278, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157378, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101049, 43),
      ))
    }

@delegate:ResourceContentHash(525_844_065)
public val Res.string.documents_type_medical: StringResource by lazy {
      StringResource("string:documents_type_medical", "documents_type_medical", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112318, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157430, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101093, 42),
      ))
    }

@delegate:ResourceContentHash(609_544_984)
public val Res.string.documents_type_ohs: StringResource by lazy {
      StringResource("string:documents_type_ohs", "documents_type_ohs", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112361, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157485, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101136, 30),
      ))
    }

@delegate:ResourceContentHash(1_954_569_474)
public val Res.string.documents_type_other: StringResource by lazy {
      StringResource("string:documents_type_other", "documents_type_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112392, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157548, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101167, 36),
      ))
    }

@delegate:ResourceContentHash(663_825_443)
public val Res.string.documents_upload_action: StringResource by lazy {
      StringResource("string:documents_upload_action", "documents_upload_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112460, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157620, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101235, 39),
      ))
    }

@delegate:ResourceContentHash(-2_008_235_812)
public val Res.string.documents_uploaded: StringResource by lazy {
      StringResource("string:documents_uploaded", "documents_uploaded", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112806, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158170, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101577, 50),
      ))
    }

@delegate:ResourceContentHash(779_395_323)
public val Res.string.documents_uploaded_medical_recorded: StringResource by lazy {
      StringResource("string:documents_uploaded_medical_recorded", "documents_uploaded_medical_recorded", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112504, 127),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157684, 191),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101275, 123),
      ))
    }

@delegate:ResourceContentHash(1_083_259_844)
public val Res.string.documents_uploaded_ohs_recorded: StringResource by lazy {
      StringResource("string:documents_uploaded_ohs_recorded", "documents_uploaded_ohs_recorded", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112632, 115),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 157876, 215),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101399, 119),
      ))
    }

@delegate:ResourceContentHash(-1_038_866_800)
public val Res.string.documents_uploaded_on: StringResource by lazy {
      StringResource("string:documents_uploaded_on", "documents_uploaded_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112748, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158092, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101519, 57),
      ))
    }

@delegate:ResourceContentHash(231_584_166)
public val Res.string.documents_uploading: StringResource by lazy {
      StringResource("string:documents_uploading", "documents_uploading", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112857, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158253, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101628, 51),
      ))
    }

@delegate:ResourceContentHash(1_584_932_036)
public val Res.string.done: StringResource by lazy {
      StringResource("string:done", "done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112909, 20),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158325, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101680, 20),
      ))
    }

@delegate:ResourceContentHash(-391_967_081)
public val Res.string.duplicate: StringResource by lazy {
      StringResource("string:duplicate", "duplicate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112930, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158354, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101701, 29),
      ))
    }

@delegate:ResourceContentHash(-1_417_778_036)
public val Res.string.edit: StringResource by lazy {
      StringResource("string:edit", "edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112960, 20),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158396, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101731, 20),
      ))
    }

@delegate:ResourceContentHash(-1_282_969_321)
public val Res.string.email_roster: StringResource by lazy {
      StringResource("string:email_roster", "email_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114900, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 161052, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103531, 44),
      ))
    }

@delegate:ResourceContentHash(1_354_398_386)
public val Res.string.email_roster_checking: StringResource by lazy {
      StringResource("string:email_roster_checking", "email_roster_checking", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 112981, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158437, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101752, 81),
      ))
    }

@delegate:ResourceContentHash(869_303_766)
public val Res.string.email_roster_days: StringResource by lazy {
      StringResource("string:email_roster_days", "email_roster_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113071, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158543, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101834, 37),
      ))
    }

@delegate:ResourceContentHash(-61_233_167)
public val Res.string.email_roster_everyone: StringResource by lazy {
      StringResource("string:email_roster_everyone", "email_roster_everyone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113113, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158597, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101872, 57),
      ))
    }

@delegate:ResourceContentHash(739_623_039)
public val Res.string.email_roster_failed: StringResource by lazy {
      StringResource("string:email_roster_failed", "email_roster_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113163, 151),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158655, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101930, 135),
      ))
    }

@delegate:ResourceContentHash(1_957_459_673)
public val Res.string.email_roster_from_day: StringResource by lazy {
      StringResource("string:email_roster_from_day", "email_roster_from_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113315, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158859, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102066, 41),
      ))
    }

@delegate:ResourceContentHash(570_030_230)
public val Res.string.email_roster_hint: StringResource by lazy {
      StringResource("string:email_roster_hint", "email_roster_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113357, 185),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 158901, 297),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102108, 185),
      ))
    }

@delegate:ResourceContentHash(1_861_060_662)
public val Res.string.email_roster_nobody: StringResource by lazy {
      StringResource("string:email_roster_nobody", "email_roster_nobody", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113543, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 159199, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102294, 107),
      ))
    }

@delegate:ResourceContentHash(489_845_893)
public val Res.string.email_roster_not_published: StringResource by lazy {
      StringResource("string:email_roster_not_published", "email_roster_not_published", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113675, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 159403, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102402, 82),
      ))
    }

@delegate:ResourceContentHash(1_335_354_267)
public val Res.string.email_roster_not_set_up: StringResource by lazy {
      StringResource("string:email_roster_not_set_up", "email_roster_not_set_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113750, 151),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 159506, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102485, 111),
      ))
    }

@delegate:ResourceContentHash(-1_493_230_302)
public val Res.string.email_roster_one: StringResource by lazy {
      StringResource("string:email_roster_one", "email_roster_one", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113902, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 159702, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102597, 40),
      ))
    }

@delegate:ResourceContentHash(608_521_990)
public val Res.string.email_roster_person: StringResource by lazy {
      StringResource("string:email_roster_person", "email_roster_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113943, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 159755, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102638, 35),
      ))
    }

@delegate:ResourceContentHash(-1_037_653_684)
public val Res.string.email_roster_plan_ended: StringResource by lazy {
      StringResource("string:email_roster_plan_ended", "email_roster_plan_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 113979, 115),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 159799, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102674, 107),
      ))
    }

@delegate:ResourceContentHash(-1_480_162_484)
public val Res.string.email_roster_queued: StringResource by lazy {
      StringResource("string:email_roster_queued", "email_roster_queued", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114095, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 159971, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102782, 59),
      ))
    }

@delegate:ResourceContentHash(1_658_711_043)
public val Res.string.email_roster_section_range: StringResource by lazy {
      StringResource("string:email_roster_section_range", "email_roster_section_range", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114167, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 160055, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102842, 42),
      ))
    }

@delegate:ResourceContentHash(-1_676_594_718)
public val Res.string.email_roster_section_who: StringResource by lazy {
      StringResource("string:email_roster_section_who", "email_roster_section_who", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114210, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 160106, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102885, 44),
      ))
    }

@delegate:ResourceContentHash(251_746_312)
public val Res.string.email_roster_send: StringResource by lazy {
      StringResource("string:email_roster_send", "email_roster_send", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114255, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 160151, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102930, 33),
      ))
    }

@delegate:ResourceContentHash(-419_505_243)
public val Res.string.email_roster_sent: StringResource by lazy {
      StringResource("string:email_roster_sent", "email_roster_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114293, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 160201, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102964, 49),
      ))
    }

@delegate:ResourceContentHash(-548_492_919)
public val Res.string.email_roster_still_sending: StringResource by lazy {
      StringResource("string:email_roster_still_sending", "email_roster_still_sending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114351, 134),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 160279, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103014, 122),
      ))
    }

@delegate:ResourceContentHash(-1_709_513_141)
public val Res.string.email_roster_to_day: StringResource by lazy {
      StringResource("string:email_roster_to_day", "email_roster_to_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114486, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 160466, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103137, 35),
      ))
    }

@delegate:ResourceContentHash(-1_495_611_759)
public val Res.string.email_roster_too_soon: StringResource by lazy {
      StringResource("string:email_roster_too_soon", "email_roster_too_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114526, 129),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 160510, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103173, 113),
      ))
    }

@delegate:ResourceContentHash(-442_505_613)
public val Res.string.email_roster_whole_month: StringResource by lazy {
      StringResource("string:email_roster_whole_month", "email_roster_whole_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114656, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 160684, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103287, 52),
      ))
    }

@delegate:ResourceContentHash(-174_949_912)
public val Res.string.email_roster_without_email: StringResource by lazy {
      StringResource("string:email_roster_without_email", "email_roster_without_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114813, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 160917, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103452, 78),
      ))
    }

@delegate:ResourceContentHash(-1_084_854_582)
public val Res.string.email_roster_without_email_hint: StringResource by lazy {
      StringResource("string:email_roster_without_email_hint", "email_roster_without_email_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114709, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 160745, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103340, 111),
      ))
    }

@delegate:ResourceContentHash(1_526_181_073)
public val Res.string.employee: StringResource by lazy {
      StringResource("string:employee", "employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 121380, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 170504, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109507, 28),
      ))
    }

@delegate:ResourceContentHash(-460_064_644)
public val Res.string.employee_add_someone_new: StringResource by lazy {
      StringResource("string:employee_add_someone_new", "employee_add_someone_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 114953, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 161133, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 103576, 64),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString13Resources(map: MutableMap<String, StringResource>) {
  map.put("day_wednesday", Res.string.day_wednesday)
  map.put("day_wednesday_in_sentence", Res.string.day_wednesday_in_sentence)
  map.put("delete", Res.string.delete)
  map.put("delete_account", Res.string.delete_account)
  map.put("delete_account_confirm", Res.string.delete_account_confirm)
  map.put("delete_account_other_apps", Res.string.delete_account_other_apps)
  map.put("delete_account_owns_workplaces", Res.string.delete_account_owns_workplaces)
  map.put("delete_account_text", Res.string.delete_account_text)
  map.put("delete_account_title", Res.string.delete_account_title)
  map.put("delete_account_type", Res.string.delete_account_type)
  map.put("delete_account_word", Res.string.delete_account_word)
  map.put("delete_named_confirm", Res.string.delete_named_confirm)
  map.put("desktop_sign_in_browser_done_text", Res.string.desktop_sign_in_browser_done_text)
  map.put("desktop_sign_in_browser_done_title", Res.string.desktop_sign_in_browser_done_title)
  map.put("desktop_sign_in_browser_failed", Res.string.desktop_sign_in_browser_failed)
  map.put("desktop_update_available", Res.string.desktop_update_available)
  map.put("desktop_update_download", Res.string.desktop_update_download)
  map.put("desktop_update_later", Res.string.desktop_update_later)
  map.put("details", Res.string.details)
  map.put("dialog_saved_live", Res.string.dialog_saved_live)
  map.put("dialog_section_access", Res.string.dialog_section_access)
  map.put("dialog_section_assignment", Res.string.dialog_section_assignment)
  map.put("dialog_section_bank", Res.string.dialog_section_bank)
  map.put("dialog_section_basics", Res.string.dialog_section_basics)
  map.put("dialog_section_contact", Res.string.dialog_section_contact)
  map.put("dialog_section_contract", Res.string.dialog_section_contract)
  map.put("dialog_section_engagement", Res.string.dialog_section_engagement)
  map.put("dialog_section_pay", Res.string.dialog_section_pay)
  map.put("dialog_section_payroll_facts", Res.string.dialog_section_payroll_facts)
  map.put("dialog_section_week", Res.string.dialog_section_week)
  map.put("documents_add", Res.string.documents_add)
  map.put("documents_add_title", Res.string.documents_add_title)
  map.put("documents_delete_confirm", Res.string.documents_delete_confirm)
  map.put("documents_delete_title", Res.string.documents_delete_title)
  map.put("documents_deleted", Res.string.documents_deleted)
  map.put("documents_drop", Res.string.documents_drop)
  map.put("documents_empty", Res.string.documents_empty)
  map.put("documents_expires_on", Res.string.documents_expires_on)
  map.put("documents_expires_on_hint", Res.string.documents_expires_on_hint)
  map.put("documents_expiry_hr_records", Res.string.documents_expiry_hr_records)
  map.put("documents_expiry_invalid", Res.string.documents_expiry_invalid)
  map.put("documents_expiry_records_dates", Res.string.documents_expiry_records_dates)
  map.put("documents_expiry_until", Res.string.documents_expiry_until)
  map.put("documents_file_empty", Res.string.documents_file_empty)
  map.put("documents_file_too_large", Res.string.documents_file_too_large)
  map.put("documents_file_unreadable", Res.string.documents_file_unreadable)
  map.put("documents_file_unsupported", Res.string.documents_file_unsupported)
  map.put("documents_intro_mine", Res.string.documents_intro_mine)
  map.put("documents_intro_team", Res.string.documents_intro_team)
  map.put("documents_medical_hint", Res.string.documents_medical_hint)
  map.put("documents_mine", Res.string.documents_mine)
  map.put("documents_no_expiry", Res.string.documents_no_expiry)
  map.put("documents_not_available", Res.string.documents_not_available)
  map.put("documents_not_signature", Res.string.documents_not_signature)
  map.put("documents_open", Res.string.documents_open)
  map.put("documents_queue", Res.string.documents_queue)
  map.put("documents_refused", Res.string.documents_refused)
  map.put("documents_title_mine", Res.string.documents_title_mine)
  map.put("documents_title_of", Res.string.documents_title_of)
  map.put("documents_transfer_failed", Res.string.documents_transfer_failed)
  map.put("documents_type", Res.string.documents_type)
  map.put("documents_type_contract", Res.string.documents_type_contract)
  map.put("documents_type_medical", Res.string.documents_type_medical)
  map.put("documents_type_ohs", Res.string.documents_type_ohs)
  map.put("documents_type_other", Res.string.documents_type_other)
  map.put("documents_upload_action", Res.string.documents_upload_action)
  map.put("documents_uploaded", Res.string.documents_uploaded)
  map.put("documents_uploaded_medical_recorded", Res.string.documents_uploaded_medical_recorded)
  map.put("documents_uploaded_ohs_recorded", Res.string.documents_uploaded_ohs_recorded)
  map.put("documents_uploaded_on", Res.string.documents_uploaded_on)
  map.put("documents_uploading", Res.string.documents_uploading)
  map.put("done", Res.string.done)
  map.put("duplicate", Res.string.duplicate)
  map.put("edit", Res.string.edit)
  map.put("email_roster", Res.string.email_roster)
  map.put("email_roster_checking", Res.string.email_roster_checking)
  map.put("email_roster_days", Res.string.email_roster_days)
  map.put("email_roster_everyone", Res.string.email_roster_everyone)
  map.put("email_roster_failed", Res.string.email_roster_failed)
  map.put("email_roster_from_day", Res.string.email_roster_from_day)
  map.put("email_roster_hint", Res.string.email_roster_hint)
  map.put("email_roster_nobody", Res.string.email_roster_nobody)
  map.put("email_roster_not_published", Res.string.email_roster_not_published)
  map.put("email_roster_not_set_up", Res.string.email_roster_not_set_up)
  map.put("email_roster_one", Res.string.email_roster_one)
  map.put("email_roster_person", Res.string.email_roster_person)
  map.put("email_roster_plan_ended", Res.string.email_roster_plan_ended)
  map.put("email_roster_queued", Res.string.email_roster_queued)
  map.put("email_roster_section_range", Res.string.email_roster_section_range)
  map.put("email_roster_section_who", Res.string.email_roster_section_who)
  map.put("email_roster_send", Res.string.email_roster_send)
  map.put("email_roster_sent", Res.string.email_roster_sent)
  map.put("email_roster_still_sending", Res.string.email_roster_still_sending)
  map.put("email_roster_to_day", Res.string.email_roster_to_day)
  map.put("email_roster_too_soon", Res.string.email_roster_too_soon)
  map.put("email_roster_whole_month", Res.string.email_roster_whole_month)
  map.put("email_roster_without_email", Res.string.email_roster_without_email)
  map.put("email_roster_without_email_hint", Res.string.email_roster_without_email_hint)
  map.put("employee", Res.string.employee)
  map.put("employee_add_someone_new", Res.string.employee_add_someone_new)
}
